"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSlot = void 0;
const pixel_pigeon_1 = require("pixel-pigeon");
const createImage_1 = require("./createImage");
const createSlot = ({ condition, icons, imagePath, isSelected, button, x, y, }) => {
    const hudElementReferences = [];
    const buttonIDs = [];
    const spriteIDs = [];
    spriteIDs.push((0, pixel_pigeon_1.createSprite)({
        animationID: () => {
            const isSelectedResult = typeof isSelected === "function" ? isSelected() : isSelected;
            return isSelectedResult === true ? "selected" : "default";
        },
        animations: [
            {
                frames: [
                    {
                        height: 18,
                        sourceHeight: 18,
                        sourceWidth: 18,
                        sourceX: 0,
                        sourceY: 0,
                        width: 18,
                    },
                ],
                id: "default",
            },
            {
                frames: [
                    {
                        height: 18,
                        sourceHeight: 18,
                        sourceWidth: 18,
                        sourceX: 18,
                        sourceY: 0,
                        width: 18,
                    },
                ],
                id: "selected",
            },
        ],
        coordinates: {
            condition,
            x: x - 1,
            y: y - 1,
        },
        imagePath,
    }));
    if (typeof button !== "undefined") {
        buttonIDs.push((0, pixel_pigeon_1.createButton)({
            coordinates: {
                condition: button.condition,
                x,
                y,
            },
            height: 16,
            onClick: button.onClick,
            width: 16,
        }));
    }
    if (typeof icons !== "undefined") {
        for (const icon of icons) {
            hudElementReferences.push((0, createImage_1.createImage)({
                condition: () => (typeof condition === "undefined" || condition()) &&
                    (typeof icon.condition === "undefined" || icon.condition()),
                height: 16,
                imagePath: icon.imagePath,
                recolors: icon.recolors,
                width: 16,
                x,
                y,
            }));
        }
    }
    return (0, pixel_pigeon_1.mergeHUDElementReferences)([
        {
            buttonIDs,
            spriteIDs,
        },
        ...hudElementReferences,
    ]);
};
exports.createSlot = createSlot;
